import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@companycam/slab-web';
import Text from 'components/shared/DesignSystem/SlabTransferPortal/Text';

const StyledImage = styled.img`
  height: 400px;
  width: auto;
  object-fit: contain;
`;

const CenteredLayout = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const TemplateEmptyState = ({
  message,
  submessage,
  imageSource,
  action,
  loading,
  containerStyle,
  imageStyle,
}) => {
  return (
    <div style={containerStyle}>
      <CenteredLayout>
        {imageSource ? (
          <StyledImage
            src={imageSource}
            resizeMode="contain"
            style={imageStyle}
          />
        ) : null}
        {message ? (
          <Text size="l" family="heading" weight="600" ccMargin="xl none s">
            {message}
          </Text>
        ) : null}
        {submessage ? (
          <Text size="s" color="subtle">
            {submessage}
          </Text>
        ) : null}

        <div style={{ marginBottom: 5 }} />

        {action ? (
          <Button
            design="minimal"
            color="primary"
            icon={{
              name: action.hideIcon ? null : 'plus',
              position: 'before',
            }}
            onClick={action.onClick}
            loading={loading}
            disabled={action.disabled}
          >
            {action.label}
          </Button>
        ) : null}
      </CenteredLayout>
    </div>
  );
};

TemplateEmptyState.propTypes = {
  message: PropTypes.string,
  submessage: PropTypes.string,
  imageSource: PropTypes.node,
  action: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    hideIcon: PropTypes.bool,
  }),
  loading: PropTypes.bool,
  containerStyle: PropTypes.object,
  imageStyle: PropTypes.object,
};

export default TemplateEmptyState;
